export const getAuthMethodFromURL = (): 'sso' | 'password' | null => {
  const urlParams = new URLSearchParams(window.location.search)

  if (urlParams.get('password') === 'true') {
    return 'password'
  }

  if (urlParams.get('sso') === 'true') {
    return 'sso'
  }

  return null
}

export const shouldShowPasswordLogin = (defaultMethod: 'sso' | 'password'): boolean => {
  const urlOverride = getAuthMethodFromURL()

  // URL parameter takes precedence
  if (urlOverride !== null) {
    return urlOverride === 'password'
  }

  // Otherwise use default
  return defaultMethod === 'password'
}

export const shouldShowSSOLogin = (defaultMethod: 'sso' | 'password'): boolean => {
  const urlOverride = getAuthMethodFromURL()

  // URL parameter takes precedence
  if (urlOverride !== null) {
    return urlOverride === 'sso'
  }

  // Otherwise use default
  return defaultMethod === 'sso'
}





